import fetch from '../utils/fetch';


export function allMetaWithExt() {
  return fetch({
    method: 'GET',
    url: '/meta/allMetaWithExt',
  })
}

export function allMeta(params) {
  return fetch({
    method: 'GET',
    url: '/meta/allMeta',
    params
  })
}

export function deleteMeta(params) {
  return fetch({
    method: 'POST',
    url: "/meta/deleteMeta",
    data:params
  })
}

export function metaListByPage(params) {
  return fetch({
    method: 'GET',
    url: '/meta/metaListByPage',
    params
  })
}

export function saveMeta(params) {
  return fetch({
    method: 'POST',
    url: "/meta/saveMeta",
    data:params
  })
}

export function updateMeta(params) {
  return fetch({
    method: 'POST',
    url: "/meta/updateMeta",
    data:params
  })
}


